import GetAccount from "@/components/GetAccount";

function registerAccount() {
  return (
    <div
      style={{
        position: "absolute",
        width: "100vw",
        height: "calc(100vh - 80px)",
        background: "#f7f8fc",
        top: 80,
        zIndex: 10,
      }}
    >
      <GetAccount type="registerAccount"></GetAccount>
    </div>
  );
}

export default registerAccount;
